define([
    "underscore",
    "backbone",
    "backbone.form",
], function (_, Backbone) {

    return Backbone.Form.extend({
        url: "/rest_register/validate_land_prime_form",

        validation: {
            first_name: {
                required: true,
            },
            last_name: {
                required: true,
            },
            email: {
                required: true,
            },
            password: {
                required: true,
            },
            confirm_password: {
                required: true,
                equalTo: 'password'
            },
            citizenship_country_cd: {
                required: true,
            },
            birth: {
                required: true,
            },
            validation_passed: {
                required: true,
            },
            has_tc_consent: {
                required: true,
                acceptance: true,
            },
        },

        labels: {
            validation_passed: "Email Validation",
            has_tc_consent: "Terms and Conditions"
        }
    });
});
